<template>
  <div>
    <!-- <div id="contact-us-intro" class="support-subject-intro">{{ contactUsInfo }}</div> -->
    <div id="contact-us-form-wrapper" class="support-form-wrapper">
      

            <div class="received" v-if="showReceived">
                 <div class="support-form-title text-center text-uppercase">Contact Information</div>
                  <div>
                  <span>We have received your feedback and will contact</span>
                  <br>
                  <br>
                  <span>you as soon as possible.</span>
                  <br>
                 <a href="/">close</a>
                </div>
            </div>
      <!-- <v-form ref="form" v-model="validForm" lazy-validation>
        <v-row dense>
          <v-col cols="12" md="6">
            <div class="support-form-label">First Name</div>
            <v-text-field
              v-model="firstName"
              outlined
              solo
              flat
              color="#333333"
              autocomplete
              class="support-form-field"
              required
              :rules="firstNameRule"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <div class="support-form-label">Last Name</div>
            <v-text-field
              v-model="lastName"
              solo
              outlined
              flat
              autocomplete
              color="#333333"
              class="support-form-field"
              required
              :rules="lastNameRule"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <div class="support-form-label">Email Address</div>
            <v-text-field
              v-model="email"
              solo
              outlined
              flat
              autocomplete
              color="#333333"
              class="support-form-field"
              required
              :rules="emailAddressRule"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <div class="support-form-label">Subject (Optional but helpful)</div>
            <v-text-field
              v-model="subject"
              autocomplete
              flat
              solo
              outlined
              color="#333333"
              class="support-form-field"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <div class="support-form-label">Please Enter a Valid inquiry or Comment</div>
            <v-textarea
              v-model="question"
              flat
              outlined
              dense
              color="#333333"
              required
              :rules="formDetailRule"
            ></v-textarea>
          </v-col>
        </v-row>
        <div id="contact-us-submit-button" class="text-center">
          <v-btn
            :disabled="!validForm"
            @click="submit"
            color="#e2211c"
            outlined
            full-width
            width="400px"
            height="40px"
            :loading="customeServiceRequestSending"
          >SEND EMAIL</v-btn>
        </div>
      </v-form> -->
            <div v-if="fromcu">

              <form action="https://api.1byonehealth.com/ap/contact_info" method="post" id="selectFrom">

                  <div class="box-select-product">
                 <select name="selectproduct" id="sp" @change="changeSp()">
                    <option value style="display: none;" disabled selected>Choose the product of purchase</option>
                    <option value="A01">Weight Scale(0014)</option>
                    <option value="A02">Weight Scale(0201)</option>
                    <option value="A03">Weight Scale(white) </option>
                    <option value="A04">Bluetooth Weight Scale(balck)</option>
                    <option value="A05">Bluetooth Fat Scale(balck)</option>
                    <option value="A06">Bluetooth Fat Scale(White)</option>
                    <option value="A07">Bluetooth Fat Scale ITO(Black)</option>
                    <option value="A08">Bluetooth Fat Scale ITO</option>
                    <option value="B01">Blood Pressure Monitor(white) </option>
                    <option value="B02">Blood Pressure Monitor(balck)</option>
                    <option value="B03">Blood Pressure Monitor(balck)</option>
                    <option value="B04">Bluetooth Blood Pressure Monitor(Black)</option>
                    <option value="B05">Bluetooth Blood Pressure Monitor(White)</option>
                    <option value="B06">Bluetooth Blood Pressure Monitor</option>
                    <option value="D01">ECG Monitor</option>
                    <option value="E01">TENS</option>
                    
                    
                  </select>
                 </div>
                     <br>
                    <span>Message*</span>
                     <br>
                    <input id="selectMessage" type="text" name="Review" placeholder="" />
                    <br>
                     <br>
                    <input id="selectFirstName" type="text" name="FirstName" placeholder="FirstName*" />
                     <br>
                     <br>
                    <input id="selectLastName" type="text" name="LastName" placeholder="LastName*" />
                    <br>
                    <br>
                    <input id="selectEmail" type="text" name="email" placeholder="Email*" />
                    <br>
                    <br>
                   
                    <button type="button" @click="fromChoose">SUBMIT</button>
                  </form>

            </div>




      
    </div>



    <v-divider class="mt-5"></v-divider>
    <!-- <div id="contact-us-phone-detail" class="mt-7 contact-us-subsection">
      <v-row>
        <v-col cols="12" md="6" class="text-center">
          <v-icon color="black" class="mr-2">settings_phone</v-icon>
          <b>US :</b>
          <span>1-(909)-391-3888</span>
        </v-col>
        <v-col cols="12" md="6" class="text-center">
          <v-icon color="black" class="mr-2">settings_phone</v-icon>
          <b>UK :</b>
          <span>1-(909)-391-3888</span>
        </v-col>
      </v-row>
    </div> -->
    <!-- <div
      class="text-center mt-4"
    >1byone Products Inc. 1230 E Belmont St.Ontario, CA 91761,United States</div> -->
  </div>

  
</template>


<script>
import {
  firstNameRule,
  lastNameRule,
  emailAddressRule,
  formDetailRule
} from "../../utils/formRulesCheck";

import { contactCustomerService } from "../../api/dataFactory";
import customerServiceMixins from "../../mixins/customerServiceMixins";

export default {
  mixins: [customerServiceMixins],
  metaInfo: {
    title: "Contact Us | 1byone health",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "If you have any issues about 1byone, welcome to free contact us by online sumbit, emaill to ushelp@1byone.com, or call us (001) 909 391 3888,(001) 909 923 8883."
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "1byone,1byone contact, 1byone health official email, 1byone address, 1byone telephone, 1byone health"
      }
    ]
  },
  data: () => ({
    firstNameRule,
    lastNameRule,
    emailAddressRule,
    formDetailRule,
    validForm: true,
    showReceived:false,
    fromcu:true,
    contactUsInfo:
      "We're happy to help with any questions you may have regarding our products and corporate information.Please fill in this form to send us your inquiry. We'll be more than happy to help and will reply to you as soon as possible",
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    question: "",
    customeServiceRequestSending: false
  }),

  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.customeServiceRequestSending = true;
        let request = this.buildContactCustomerServiceRequest();
        let result = await contactCustomerService(request);
        this.customeServiceRequestSending = false;
        if (result) {
          this.$emit(
            "onCustomerServiceRequestSubmitted",
            true,
            "Your request is submitted, we will contact you shortly via email"
          );
        } else {
          this.$emit(
            "onCustomerServiceRequestFailed",
            true,
            "There is problem when submitting the request. Please try again later"
          );
        }
      }
    },

    buildContactCustomerServiceRequest() {
      let request = new FormData();
      request.append("lastName", this.firstName);
      request.append("firstName", this.lastName);
      request.append("email", this.email);
      request.append("subject", this.subject);
      request.append("content", this.question);
      request.append("recognizedUserEmail", this.recognizedUserEmail);
      return request;
    },


 changeSp(){
        let spId = document.getElementById("sp").value;
        this.chooseSP(spId);
        
     },

      chooseSP(spId){
       if(spId=="A01"){
         this.spId ="A01";
          
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07FXTB52B:5";
          if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07TLW4FSB:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FXTB52B:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07FXTB52B:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07FXTB52B:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07FXTB52B:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07FXTB52B:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FXTB52B:5";
               }
           }
        }else if(spId=="A02"){
          this.spId ="A02";
         
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07WK1V886:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B081GYJ99R:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07WMTH6MT:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07WMTH6MT:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07WMTH6MT:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07WMTH6MT:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07WMTH6MT:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07WMTH6MT:5";
               }
           }
        }else if(spId=="A03"){
          this.spId ="A03";
        
          this.tags=this.A03tags;
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B08D6BJL71:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B08D6BJL71:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B089SZG65L:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B089SZG65L:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B089SZG65L:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B089SZG65L:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B089SZG65L:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B089SZG65L:5";
               }
           }
        }else if(spId=="A04"){
          this.spId ="A04";
         
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B08FQTXDKV:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B08FQTXDKV:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08FQTXDKV:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B08FQTXDKV:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B08FQTXDKV:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B08FQTXDKV:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B08FQTXDKV:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08FQTXDKV:5";
               }
           }
        }else if(spId=="A05"){
          this.spId ="A05";
         
           if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B082W5Y6QP:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B01FHELB56:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07FFSYQDM:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFSYQDM:5";
               }
           }
        }else if(spId=="A06"){
          this.spId ="A06";
         
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B0852DHR53:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07TJS77KR:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFQ7685:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07FFQ7685:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07FFQ7685:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07FFQ7685:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07FFQ7685:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFQ7685:5";
               }
           }
        }else if(spId=="A07"){
          this.spId ="A07";
         
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07XRG2SJR:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07XRG2SJR:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07P6BPHRW:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07P6BPHRW:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07P6BPHRW:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07P6BPHRW:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07P6BPHRW:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07P6BPHRW:5";
               }
           }
        }else if(spId=="A08"){
          this.spId ="A08";
          
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07XRCHY2J:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07XRCHY2J:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07XRHMZPC:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07XRHMZPC:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07XRHMZPC:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07XRHMZPC:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07XRHMZPC:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07XRHMZPC:5";
               }
           }
        }else if(spId=="B01"){
          this.spId ="B01";
          
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B08BC1DXHF:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B08BC1DXHF:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08BC1DXHF:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B08BC1DXHF:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B08BC1DXHF:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B08BC1DXHF:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B08BC1DXHF:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08BC1DXHF:5";
               }
           }
        }else if(spId=="B02"){
          this.spId ="B02";
         
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B08BF4RDWP:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B08BF4RDWP:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08BF4RDWP:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B08BF4RDWP:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B08BF4RDWP:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B08BF4RDWP:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B08BF4RDWP:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08BF4RDWP:5";
               }
           }
        }else if(spId=="B03"){
          this.spId ="B03";
          
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B089153D4W:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B089153D4W:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B089153D4W:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B089153D4W:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B089153D4W:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B089153D4W:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B089153D4W:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B089153D4W:5";
               }
           }
        }else if(spId=="B04"){
          this.spId ="B04";
         
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B089W7H9XK:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B089W7H9XK:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B075DSY8BC:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B075DSY8BC:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B075DSY8BC:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B075DSY8BC:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B075DSY8BC:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B075DSY8BC:5";
               }
           }
        }else if(spId=="B05"){
          this.spId ="B05";
          
           if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07JG5JDD9:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
           this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07JG5JDD9:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07JG5JDD9:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07JG5JDD9:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07JG5JDD9:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07JG5JDD9:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07JG5JDD9:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07JG5JDD9:5";
               }
           }
        }else if(spId=="D01"){
          this.spId ="D01";
          
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B082Y53TCQ:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B082Y53TCQ:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07ZVV561D:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07ZVV561D:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07ZVV561D:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07ZVV561D:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07ZVV561D:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07ZVV561D:5";
               }
           }
        }else if(spId=="B06"){
          this.spId ="B06";
          
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07XTFW97H:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07XTFW97H:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07XTFW97H:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07XTFW97H:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07XTFW97H:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07XTFW97H:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07XTFW97H:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07XTFW97H:5";
               }
           }
        }else if(spId=="E01"){
          this.spId ="E01";
          
         if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B082V7WB61:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
           this.spUrl="https://www.amazon.ca/review/create-review?&asin=B082V7WB61:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B082V7WB61:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B082V7WB61:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B082V7WB61:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B082V7WB61:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B082V7WB61:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B082V7WB61:5";
               }
           }
        }else{
           this.spId ="A05";
          
           if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B082W5Y6QP:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B01FHELB56:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07FFSYQDM:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFSYQDM:5";
               }
          }
          }
        },

        checkEmail(email){
        var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        if(reg.test(email)){
          return true;
        }else{
         return false;
        }
     },

// 联系我们的提交
    fromChoose(){
      var selectproduct= this.spId;
      var Message=  document.getElementById("selectMessage").value;
      var selectFirstName=  document.getElementById("selectFirstName").value;
      var selectLastName=  document.getElementById("selectLastName").value;
      var email=  document.getElementById("selectEmail").value;

      var country;
      if(sessionStorage.getItem("asinRegion")=="EU"){
        country =this.radioVal;
      }else{
        country=sessionStorage.getItem("asinRegion");
      }

      var istrue = true;
      if(Message==""){
        document.getElementById("selectMessage").style.border="1px solid red"
         istrue= false;
      }else{
        istrue=true;
      } 
      if(selectFirstName=="" ){
        document.getElementById("selectFirstName").style.border="1px solid red"
         istrue= false;
      }else{
        istrue=true;
      }
      if(selectLastName=="" ){
        document.getElementById("selectLastName").style.border="1px solid red"
         istrue= false;
      }else{
        istrue=true;
      }
      if(email=="" ){
         document.getElementById("selectEmail").style.border="1px solid red"
         istrue= false;
      }else{
        istrue=true;
      }
        if(!this.checkEmail(email)){
     document.getElementById("selectEmail").style.border="1px solid red"
       istrue= false;
     }else{
        istrue=true;
      }

      if(istrue){
      this.$axios({
              url: defaultAxiosConfig.baseURL+"/ap/cu",
                //  url: "http://localhost:5000/ap/cu",
              method: "post",
              params: {"product_id": selectproduct, "message": Message,"firstName":selectFirstName,"lastName":selectLastName,"email":email,"country":country}
            }).then(res => {
               console.log(res);
            });
            this.showfankuichenggong();
            }
        },



      showfankuichenggong(){
       this.boxclear();
        this.showBox = true; 
      this.showBoxCU=true;
       this.showReceived=true;

    },

     boxclear(){
      this.twoDiv=false,
      this.showBoxText=false,
      this.showBoxCUright=false,
      this.showBoxAmazon=false,
      this.showBoxForm=false,
      this.showRightForm=false,
      this.showBoxGrade=false,
      this.showBoxShare=false,
      this.showBoxCU=false,
      this.showBox=false,
      this.showboxContact=false,
      this.showloginsuccessful=false,
      this.showReceived=false,
      this.fromcu=false
    },

  }


  
};
</script>


<style>
.box-select-product{
 background-color: #CCCCCC;
 width: 70%;
}

</style>